import React from 'react';
import { FontWeight, Text, Heading, UserMessage, LiliButton, LiliLink } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { ReactComponent as WatchIcon } from '../../../assets/icons/svg/colored-icons/ic-colored-watch.svg';
import { CloseButton } from '../../../DesignSystem/LiliCloseButton/CloseButton';

interface IProps {
  onClose: () => void;
}

export const TemporaryBlocked = ({ onClose }: IProps) => {
  const { t: inviteT } = useTranslation('inviteEN');
  const supportEmail = 'support@lili.co';

  return (
    <UserMessage onClick={onClose} id='user-locked-modal'>
      <div className='flex flex-col items-center w-[468px] bg-bw00 rounded-[12px] px-[32px] pb-[40px]'>
        <div className='w-full justify-end pt-[18px]  flex'>
          <CloseButton onClick={onClose} className='translate-x-[16px] w-[32px] hover:cursor-pointer ' id='closeFlow' />
        </div>
        <WatchIcon className='mb-[30px]' />

        <Heading.H7 fontWeight={FontWeight.SEMIBOLD} className='text-text-main-primary mb-[8px]'>
          {inviteT('USER_LOCKED_POPUP.TITLE')}
        </Heading.H7>
        <Text.H10 fontWeight={FontWeight.SEMIBOLD} className='text-text-main-primary text-center'>
          {inviteT('USER_LOCKED_POPUP.DESCRIPTION1')}
        </Text.H10>
        <Text.H10 fontWeight={FontWeight.SEMIBOLD} className='text-text-main-primary text-center'>
          {inviteT('USER_LOCKED_POPUP.DESCRIPTION2')}
        </Text.H10>
        <Heading.H10 className='text-text-main-primary text-center mt-[32px]'>
          {inviteT('USER_LOCKED_POPUP.DISCLAIMER')}
        </Heading.H10>
        <LiliLink href={`mailto:${supportEmail}`} title={supportEmail} id='support-link' className='mb-[32px]' />
        <LiliButton onClick={onClose} title={inviteT('USER_LOCKED_POPUP.CTA')} className='  w-full' id='gotItCta' />
      </div>
    </UserMessage>
  );
};
